export default (x => {
  if (typeof x === 'string') {
    return x;
  } else if (Array.isArray(x)) {
    return x.reduce((acc, transform) => {
      var key = Object.keys(transform)[0];
      switch (key) {
        case 'translateY':
          return "".concat(acc, " translateY(").concat(transform[key], "px)");
        case 'translateX':
          return "".concat(acc, " translateX(").concat(transform[key], "px)");
        case 'scale':
          return "".concat(acc, " scale(").concat(transform[key], ")");
        case 'rotate':
          return "".concat(acc, " rotate(").concat(transform[key], ")");
        default:
          return acc;
      }
    }, '');
  }
});
//# sourceMappingURL=index.js.map